import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment-timezone';
import { Modal, Button } from 'react-bootstrap';
import { faEdit, faSave, faRefresh, faThumbsUp, faTrash, faSpinner, faEye, faClock, faLightbulb, faHeart, faPoll, faImage, faVideo, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';
import Swal from 'sweetalert2';
import noDataImage from "../assets/nodata.png"
import { Link, useNavigate } from 'react-router-dom';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import SideNavbar from './helpers/SideNavbar';
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import TimezoneSelect from 'react-timezone-select';
import { useMutation } from '@tanstack/react-query';
import { useCreatePoll } from '../apis/knackfeeds';
import { useFeatureLimits } from './FeatureLimits/FeatureLimitsProvider';
import { FEATURE_NAMES } from '../apis/featureLimits';
import { FloatingUsageIndicator } from './FeatureLimits/FeatureUsageIndicator';
import { getAllActivePlatforms, formatPlatformNamesForButton, formatPlatformNamesForAlert } from '../utils/platformUtils';



const LatestTrendingPost = () => {
  const navigate = useNavigate()
  const { logFeatureUsage, isFreeUser, isSubscriber, checkFeatureAccess } = useFeatureLimits();
  // Usage logging is handled by the backend API

  const [posts, setPosts] = useState([]);
  const [approving, setApproving] = useState({});
  const [rejecting, setRejecting] = useState({});
  const [wishlistLoading, setWishlistLoading] = useState({});
  const [showPending, setShowPending] = useState(true); // default true
  const [showWishlist, setShowWishlist] = useState(false);
  const [showRejected, setShowRejected] = useState(false);
  const [allPosts, setAllPosts] = useState([]); // complete list
  const [statusFilter, setStatusFilter] = useState('Pending');

  const [error, setError] = useState('');

  const [loading, setLoading] = useState(false); // Loading state for spinner
  const [options, setOptions] = useState([]); // State for dropdown options
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedTimezone, setSelectedTimezone] = useState({}); // New state for timezone
  const [promptData1, setPromptData1] = useState([]); // Holds both new and existing prompts
  const [promptDatainterest, setPromptDatainterest] = useState([]); // Holds both new and existing prompts
  const [suggestedpromptDatainterest, setSuggestedPromptDatainterest] = useState([]); // Holds both new and existing prompts
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Loader state
  const UserID = localStorage.getItem("UserID")
  const accessToken = localStorage.getItem('AccessToken');
  const tokenID = localStorage.getItem('Tokenid');
  const RoleID = localStorage.getItem('RoleID');
  const SelectedUserEmail = localStorage.getItem('UserEmail');
  const SelectedUserEmail1 = localStorage.getItem('Email');
  const SelectedUserAccountId = localStorage.getItem('SelectedUserAccountId');
  const [showModal, setShowModal] = useState(false);
  const [selectedContentId, setSelectedContentID] = useState();

  const userProfile = JSON.parse(localStorage.getItem("userProfile")) || [];


  const AccountId = userProfile ? userProfile[0]?.AccountId : null;
  const LinkedinEmail = RoleID == 2 ? SelectedUserEmail1 : SelectedUserEmail
  const AccountType = localStorage.getItem('AccountType');
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 576);

  // Set default timezone to user's timezone when modal opens
  useEffect(() => {
    if (showModal && (!selectedTimezone || (typeof selectedTimezone === 'object' && Object.keys(selectedTimezone).length === 0))) {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      setSelectedTimezone(userTimezone);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [scheduleDateTime, setScheduleDateTime] = useState('');
  const [endDate, setEndDate] = useState(''); // New state for end date
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [showPollModal, setShowPollModal] = useState(false);
  const [questionData, setQuestionData] = useState({ question: "", options: ["", ""] });
  const { mutate, data: pollData, isLoading: loadingPoll } = useCreatePoll()
  const [SinglePost, setPost] = useState({});
  const [durationDays, setDurationDays] = useState(3); // Default 3 days
  const [expandedPosts, setExpandedPosts] = useState({});
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [activeMedia, setActiveMedia] = useState(null);
  const [enabledPlatforms, setEnabledPlatforms] = useState([]);
  const [platformsLoading, setPlatformsLoading] = useState(true);
  const [selectedPlatforms, setSelectedPlatforms] = useState([]); // Array of platform codes for approve: ['linkedin', 'facebook', 'instagram']
  const [schedulePlatforms, setSchedulePlatforms] = useState([]); // Array of platform codes for schedule: ['linkedin', 'facebook', 'instagram']
  const [showPlatformModal, setShowPlatformModal] = useState(false);
  const [pendingContentId, setPendingContentId] = useState(null);
  const [pendingImageURL, setPendingImageURL] = useState(null);
  const [availablePlatforms, setAvailablePlatforms] = useState([]);


  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSelectCategory = (selectedOptions) => {
    setSelectedValues(selectedOptions);
  };

  const handleedit = (post) => {
    
    navigate(`/updatelatesttrendingnews/${post.ContentID}`)
  };

  const handleschedulepost = (post) => {
    setSelectedContentID(post.ContentID);
    // Reset schedule platforms to default when opening modal
    const storedAccountType = localStorage.getItem('AccountType');
    if (storedAccountType === 'User' || storedAccountType === 'user') {
      setSchedulePlatforms(['linkedin']);
    } else {
      // For Page accounts, set to all available platforms (or wait if still loading)
      if (availablePlatforms && availablePlatforms.length > 0) {
        setSchedulePlatforms(availablePlatforms.map(p => p.code));
      } else {
        // If platforms not loaded yet, will be set when they load via useEffect
        // For now, set empty array - the UI will show loading state
        setSchedulePlatforms([]);
      }
    }
    setShowModal(true);
  };

  // Handle platform toggle for schedule modal
  const handleSchedulePlatformToggle = (platformCode) => {
    setSchedulePlatforms(prev => {
      if (prev.includes(platformCode)) {
        // If unchecking would leave no platforms selected, prevent it
        if (prev.length === 1) {
          return prev; // Keep at least one platform selected
        }
        return prev.filter(code => code !== platformCode);
      } else {
        return [...prev, platformCode];
      }
    });
  };


  const handleClose = () => {
    setShowModal(false);
  };

  // Shared validation function to check if schedule date exceeds subscription/trial end date
  const validateScheduleDateAgainstSubscription = (scheduleDateValue) => {
    const selectedDate = new Date(scheduleDateValue);
    selectedDate.setHours(23, 59, 59, 999);

    // Check if user is on free trial
    if (isFreeUser && isFreeUser()) {
      // For free users, check against free trial end date (CreatedDate + 30 days + TrialExtensionDays)
      const createdDateStr = localStorage.getItem('CreatedDate');
      if (createdDateStr) {
        const createdDate = new Date(createdDateStr);
        const trialExtensionDays = userProfile && userProfile[0]?.TrialExtensionDays ? parseInt(userProfile[0].TrialExtensionDays) : 0;
        const freeTrialEndDate = new Date(createdDate);
        freeTrialEndDate.setDate(freeTrialEndDate.getDate() + 30 + trialExtensionDays);
        freeTrialEndDate.setHours(23, 59, 59, 999);

        if (selectedDate > freeTrialEndDate) {
          const formattedTrialEnd = freeTrialEndDate.toLocaleDateString();
          return {
            isValid: false,
            error: `Schedule date cannot exceed your free trial end date (${formattedTrialEnd}). Please upgrade to schedule beyond your trial period.`,
            formattedEndDate: formattedTrialEnd
          };
        }
      }
    } else {
      // For subscribed users, check against subscription end date
      const subscriptionEndDate = localStorage.getItem('subscriptionEndDate');
      if (subscriptionEndDate && subscriptionEndDate !== 'null') {
        const subscriptionEnd = new Date(subscriptionEndDate);
        subscriptionEnd.setHours(23, 59, 59, 999);
        
        if (selectedDate > subscriptionEnd) {
          const formattedSubscriptionEnd = subscriptionEnd.toLocaleDateString();
          return {
            isValid: false,
            error: `Schedule date cannot exceed your subscription end date (${formattedSubscriptionEnd}). Please select an earlier date or renew your subscription.`,
            formattedEndDate: formattedSubscriptionEnd
          };
        }
      }
    }

    return { isValid: true, error: null };
  };

  const handleScheduleDateTimeChange = (e) => {
    const selectedDateTime = e.target.value;
    setScheduleDateTime(selectedDateTime);
    setError(''); // Clear previous errors

    // Validate against subscription end date in real-time
    if (selectedDateTime) {
      const validation = validateScheduleDateAgainstSubscription(selectedDateTime);
      if (!validation.isValid) {
        setError(validation.error);
      }
    }
  };

  const [currentPage, setCurrentPage] = useState(0);
  const postsPerPage = 4; // Number of posts per page
  const [cacheByStatus, setCacheByStatus] = useState({}); // { Pending: [...], WishListed: [...], Archived: [...] }

  const fetchPosts = async (statusArg, force = false) => {
    setLoading(true);
    try {
      const statusKey = String(statusArg ?? statusFilter);

      // Serve from cache unless force-refresh is requested
      if (!force && cacheByStatus[statusKey] && cacheByStatus[statusKey].length) {
        setPosts(cacheByStatus[statusKey]);
        setLoading(false);
        return;
      }

      const statusParam = encodeURIComponent(statusKey);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api//getalllatestnewsbyUserID/${UserID}?status=${statusParam}`);
      const fetched = response.data || [];

      // Update cache and current view
      setCacheByStatus(prev => ({ ...prev, [statusKey]: fetched }));
      setPosts(fetched);
      setLoading(false);
    } catch (err) {
      console.error('Failed to fetch posts:', err.message);
      setError('Failed to fetch posts');
      setLoading(false);
    }
  };
  const applyFilters = () => {
    // Server now returns filtered data; keep for backward compatibility if needed
    const filtered = allPosts.filter(post => post.Status === statusFilter);
    if (allPosts.length && !posts.length && filtered.length) setPosts(filtered);
  };


  useEffect(() => {
    fetchPosts(statusFilter);
  }, [UserID, statusFilter]);

  // Pagination logic
  const offset = currentPage * postsPerPage;
  const currentPosts = posts.slice(offset, offset + postsPerPage);
  const pageCount = Math.ceil(posts.length / postsPerPage);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!accessToken || !tokenID) {
      setError('Access token or token ID is missing');
      return;
    }
    if (!scheduleDateTime) {
      setError('Please provide schedule date & time');
      return;
    }

    // Handle both string and object formats for timezone
    const timezoneValue = typeof selectedTimezone === 'string' ? selectedTimezone : selectedTimezone?.value;
    
    if (!selectedTimezone || !timezoneValue) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Timezone Required',
        text: 'Please select a timezone.',
        showConfirmButton: true,
      });
      setLoading(false);
      return;
    }

    // Validate that schedule date does not exceed subscription/trial end date (final check before submit)
    const validation = validateScheduleDateAgainstSubscription(scheduleDateTime);
    if (!validation.isValid) {
      const title = isFreeUser && isFreeUser() 
        ? 'Schedule Date Exceeds Free Trial Limit' 
        : 'Schedule Date Exceeds Subscription';
      
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: title,
        text: validation.error,
        showConfirmButton: true,
        confirmButtonText: 'OK',
        confirmButtonColor: '#2e3192',
        showCancelButton: false
      });
      setError(validation.error);
      return;
    }

    // Validate that at least one platform is selected
    if (!schedulePlatforms || schedulePlatforms.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Platform Selected',
        text: 'Please select at least one platform to schedule to.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#2e3192',
        timer: 2000
      });
      setLoading(false);
      return;
    }

    // Convert date to the correct timezone and extract the day
    const userTimezone = timezoneValue; // Timezone selected by the user
    const prompts = selectedValues.value
    const formattedDate = moment.tz(scheduleDateTime, userTimezone); // Adjust datetime to selected timezone
    const dayOfWeek = formattedDate.format('dddd'); // Get day of the week in full format (e.g., Monday)
    const scheduleDate = formattedDate.format('YYYY-MM-DD');
    const scheduleTime = formattedDate.format('HH:mm');

    // Check feature access before scheduling - check limits for the scheduled date (future date if scheduled for future)
    const accessCheck = await checkFeatureAccess(FEATURE_NAMES.KNACK_FEEDS, userTimezone, scheduleDate);
    if (!accessCheck.canProceed) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Knack Feeds Limit Reached',
        text: `You have reached your limit for Knack Feeds${scheduleDate !== moment.tz(userTimezone).format('YYYY-MM-DD') ? ` on ${scheduleDate}` : ' today'}. Please try again${scheduleDate !== moment.tz(userTimezone).format('YYYY-MM-DD') ? ' on a different date' : ' tomorrow'}.`,
        showConfirmButton: true,
        confirmButtonText: 'OK',
        confirmButtonColor: '#2e3192',
        showCancelButton: false
      });
      setLoading(false);
      return;
    }

    const daysString = selectedDays.map(day => day.value).join(','); // Stringify the selected days

    //  const prompts = selectedValues.map(prompt => encodeURIComponent(prompt.value)).join('|'); // Encode prompts

    setLoading(true); // Start loading spinner
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/schedule-post`, {
        Days: dayOfWeek, // Send the derived day
        ScheduleTime: scheduleTime,
        StartDate: scheduleDate,
        EndDate: scheduleDate,
        Prompt: null,
        AccessToken: accessToken,
        Tokenid: tokenID,
        TimeZone: timezoneValue, // Use timezoneValue to handle both string and object formats
        Email: LinkedinEmail,
        AccountId: RoleID == 1 || RoleID == 4 ? AccountId : SelectedUserAccountId,
        UserID: UserID,
        Status: 'PENDING',
        PromptType: 3,
        AccountType: AccountType,
        ContentId: selectedContentId,
        platforms: schedulePlatforms // Send selected platforms array
      });

      setMessage(response.data.message);

      // Check for both success messages (regular posts and KnackFeeds)
      if (response.data.message === 'Post scheduled successfully' || response.data.message === 'KnackFeed scheduled successfully') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'KnackFeed scheduled successfully',
          showConfirmButton: false,
          timer: 3000
        });
        // Refetch current status after approve
        fetchPosts(statusFilter, true);
        resetForm();
        
        // 🔄 Refresh feature usage data to show updated limits (with delay to ensure backend processing)
        setTimeout(() => {
          console.log('🔄 Attempting to refresh feature usage after KnackFeeds scheduling...');
          if (window.refreshFeatureUsage) {
            window.refreshFeatureUsage();
            console.log('✅ Feature usage refresh triggered for KnackFeeds scheduling');
          } else {
            console.log('❌ window.refreshFeatureUsage not available');
          }
        }, 1000); // 1 second delay to ensure backend usage logging is complete
        
        navigate("/KnackFeeds")
        setShowModal(false);
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error scheduling KnackFeed post!',
          text: response.data.message || 'An error occurred while scheduling the post.',
          showConfirmButton: false,
          timer: 3000
        });
      }
      setError('');
    } catch (error) {
      setError('Failed to schedule the post');
      setMessage('');
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };
  const resetForm = () => {
    setSelectedDays([]);
    setScheduleDateTime('');
    setEndDate('');
    setEmail('');
    setSelectedTimezone({});
  };

  // Handle platform toggle for platform selection modal
  const handlePlatformToggle = (platformCode) => {
    setSelectedPlatforms(prev => {
      if (prev.includes(platformCode)) {
        // If unchecking would leave no platforms selected, prevent it
        if (prev.length === 1) {
          return prev; // Keep at least one platform selected
        }
        return prev.filter(code => code !== platformCode);
      } else {
        return [...prev, platformCode];
      }
    });
  };

  // Actual approve function that posts to selected platforms
  const performApprove = async (ContentID, platformsToPost, imageURL = null) => {
    try {
      setApproving((prev) => ({ ...prev, [ContentID]: true })); // Start loading

      // Validate that at least one platform is selected
      if (!platformsToPost || platformsToPost.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'No Platform Selected',
          text: 'Please select at least one platform to post to.',
          confirmButtonText: 'OK',
          confirmButtonColor: '#2e3192',
          timer: 2000
        });
        setApproving((prev) => ({ ...prev, [ContentID]: false }));
        return;
      }

      // Check feature access before approving (no platform settings check needed)
      const accessCheck = await checkFeatureAccess(FEATURE_NAMES.KNACK_FEEDS);
      if (!accessCheck.canProceed) {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'KnackFeeds Limit Reached',
          text: `You have reached your limit for KnackFeeds. Please try again tomorrow.`,
          showConfirmButton: true,
          confirmButtonText: 'OK',
          confirmButtonColor: '#2e3192',
          showCancelButton: false
        });
        setApproving((prev) => ({ ...prev, [ContentID]: false }));
        return;
      }

      const accessToken = localStorage.getItem('AccessToken');
      const tokenID = localStorage.getItem('Tokenid');

      if (!accessToken || !tokenID) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Missing LinkedIn credentials!',
          showConfirmButton: false,
          timer: 3000
        });
        setApproving((prev) => ({ ...prev, [ContentID]: false }));
        return;
      }

      // Calculate ScheduledTimeAsPerZone in the user's timezone
      // Get user's timezone - use selected timezone if available, otherwise use browser's timezone
      // Handle both string and object formats for timezone
      const userTimezone = (typeof selectedTimezone === 'string' ? selectedTimezone : selectedTimezone?.value) || Intl.DateTimeFormat().resolvedOptions().timeZone;
      const nowInUserTimezone = moment.tz(userTimezone);
      const scheduledTimeAsPerZone = nowInUserTimezone.format('HH:mm:ss');

      // Convert platforms array to comma-separated string for query parameter
      const platformsParam = platformsToPost.join(',');

      // Build query string with optional imageURL parameter
      let queryString = `ContentID=${ContentID}&accessToken=${accessToken}&tokenID=${tokenID}&AccountType=${AccountType}&timezone=${encodeURIComponent(userTimezone)}&scheduledTimeAsPerZone=${encodeURIComponent(scheduledTimeAsPerZone)}&platforms=${encodeURIComponent(platformsParam)}`;
      if (imageURL) {
        queryString += `&imageURL=${encodeURIComponent(imageURL)}`;
        console.log('📤 [KnackFeeds Frontend] Sending imageURL to backend:', imageURL);
      } else {
        console.log('⚠️ [KnackFeeds Frontend] No imageURL found, not sending image parameter');
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/postToLinkedInlatestnews?${queryString}`
      );

      // Check for image validation errors BEFORE showing success
      if (response.data?.error && response.data?.errorType === 'image_validation') {
        const platformName = response.data.platform === 'instagram' ? 'Instagram' : response.data.platform;
        const errorDetails = response.data.errorDetails || {};
        const aspectRatio = errorDetails.aspectRatio || 'N/A';
        const dimensions = errorDetails.dimensions || 'N/A';
        
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: `${platformName} Image Error`,
          html: `
            <div style="text-align: left;">
              <p style="margin-bottom: 10px;"><strong>${response.data.message}</strong></p>
              ${dimensions !== 'N/A' ? `<p style="margin-bottom: 5px;">Image dimensions: ${dimensions}</p>` : ''}
              ${aspectRatio !== 'N/A' ? `<p style="margin-bottom: 5px;">Aspect ratio: ${aspectRatio}:1</p>` : ''}
              <p style="margin-top: 10px; color: #666;">Please upload a different image with a valid aspect ratio (between 0.8:1 and 1.91:1).</p>
            </div>
          `,
          showConfirmButton: true,
          confirmButtonText: 'OK',
          confirmButtonColor: '#2e3192',
          width: '500px'
        });
        return; // Don't proceed with success handling
      }
      
      // Check for image required errors
      if (response.data?.error && response.data?.errorType === 'image_required') {
        const platformName = response.data.platform === 'instagram' ? 'Instagram' : response.data.platform;
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: `${platformName} Image Required`,
          text: response.data.message || 'Image is required for this platform.',
          showConfirmButton: true,
          confirmButtonText: 'OK',
          confirmButtonColor: '#2e3192'
        });
        return; // Don't proceed with success handling
      }

      if (response.status === 200 && response.data?.message?.includes("successfully")) {
        // Usage logging is handled by the backend API

        // Get platform names for success message
        const platformNames = availablePlatforms
          .filter(p => platformsToPost.includes(p.code))
          .map(p => p.name);

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: `Post approved and published${platformNames.length > 0 ? ` on ${platformNames.join(' & ')}` : '!'}`,
          showConfirmButton: false,
          timer: 3000
        });

        setPosts((prevPosts) => prevPosts.filter(post => post.ContentID !== ContentID));
        // Refetch current status after archive
        fetchPosts(statusFilter, true);
        
        // Refresh usage data after successful posting (with delay to ensure backend processing)
        setTimeout(() => {
          console.log('🔄 Attempting to refresh feature usage after KnackFeeds approval...');
          if (window.refreshFeatureUsage) {
            window.refreshFeatureUsage();
            console.log('✅ Feature usage refresh triggered for KnackFeeds approval');
          } else {
            console.log('❌ window.refreshFeatureUsage not available');
          }
        }, 1000); // 1 second delay to ensure backend processing is complete
      } else {
        // Check for image validation errors in error response
        if (response.data?.error && response.data?.errorType === 'image_validation') {
          const platformName = response.data.platform === 'instagram' ? 'Instagram' : response.data.platform;
          const errorDetails = response.data.errorDetails || {};
          const aspectRatio = errorDetails.aspectRatio || 'N/A';
          const dimensions = errorDetails.dimensions || 'N/A';
          
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: `${platformName} Image Error`,
            html: `
              <div style="text-align: left;">
                <p style="margin-bottom: 10px;"><strong>${response.data.message}</strong></p>
                ${dimensions !== 'N/A' ? `<p style="margin-bottom: 5px;">Image dimensions: ${dimensions}</p>` : ''}
                ${aspectRatio !== 'N/A' ? `<p style="margin-bottom: 5px;">Aspect ratio: ${aspectRatio}:1</p>` : ''}
                <p style="margin-top: 10px; color: #666;">Please upload a different image with a valid aspect ratio (between 0.8:1 and 1.91:1).</p>
              </div>
            `,
            showConfirmButton: true,
            confirmButtonText: 'OK',
            confirmButtonColor: '#2e3192',
            width: '500px'
          });
        } else {
          const platformNames = availablePlatforms
            .filter(p => platformsToPost.includes(p.code))
            .map(p => p.name);
          const errorMessage = platformNames.length > 0 
            ? `Error approving post to ${platformNames.join(' & ')}!`
            : 'Error approving post!';
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: errorMessage,
            text: response.data?.message || "Unknown error occurred",
            showConfirmButton: false,
            timer: 3000
          });
        }
      }
    } catch (error) {
      console.error('Error posting:', error);
      
      // Check for image validation errors
      if (error.response?.data?.error && error.response?.data?.errorType === 'image_validation') {
        const platformName = error.response.data.platform === 'instagram' ? 'Instagram' : error.response.data.platform;
        const errorDetails = error.response.data.errorDetails || {};
        const aspectRatio = errorDetails.aspectRatio || 'N/A';
        const dimensions = errorDetails.dimensions || 'N/A';
        
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: `${platformName} Image Error`,
          html: `
            <div style="text-align: left;">
              <p style="margin-bottom: 10px;"><strong>${error.response.data.message}</strong></p>
              ${dimensions !== 'N/A' ? `<p style="margin-bottom: 5px;">Image dimensions: ${dimensions}</p>` : ''}
              ${aspectRatio !== 'N/A' ? `<p style="margin-bottom: 5px;">Aspect ratio: ${aspectRatio}:1</p>` : ''}
              <p style="margin-top: 10px; color: #666;">Please upload a different image with a valid aspect ratio (between 0.8:1 and 1.91:1).</p>
            </div>
          `,
          showConfirmButton: true,
          confirmButtonText: 'OK',
          confirmButtonColor: '#2e3192',
          width: '500px'
        });
        return;
      }
      
      // Check if it's a limit exceeded error (402)
      if (error.response?.status === 402) {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Knack Feeds Limit Reached',
          text: `You have reached your limit for Knack Feeds. Please try again tomorrow.`,
          showConfirmButton: true,
          confirmButtonText: 'OK',
          confirmButtonColor: '#2e3192',
          showCancelButton: false
        });
      } else {
        const platformNames = availablePlatforms
          .filter(p => platformsToPost.includes(p.code))
          .map(p => p.name);
        const errorMessage = platformNames.length > 0 
          ? `An error occurred while posting to ${platformNames.join(' & ')}.`
          : "An error occurred while posting.";
        Swal.fire({
          position: 'center',
          icon: 'error',
          text: error.response?.data?.message || error.message || errorMessage,
          showConfirmButton: false,
          timer: 3000
        });
      }
    } finally {
      setApproving((prev) => ({ ...prev, [ContentID]: false })); // Stop loading
    }
  };

  // Handle approve button click - show modal for Page accounts, direct post for User accounts
  const handleApprove = async (ContentID, post = null) => {
    const storedAccountType = localStorage.getItem('AccountType');
    
    // Get image URL from post object if available
    const imageURL = post ? (post.ImageURL || post.PostImage || post.MediaURL || post.Image || null) : null;
    
    console.log('🖼️ [KnackFeeds Frontend] Image URL extraction:', {
      ContentID,
      postObject: post,
      imageURL: imageURL,
      ImageURL: post?.ImageURL,
      PostImage: post?.PostImage,
      MediaURL: post?.MediaURL,
      Image: post?.Image
    });
    
    // For User accounts, directly post to LinkedIn without showing modal
    if (storedAccountType === 'User' || storedAccountType === 'user') {
      await performApprove(ContentID, ['linkedin'], imageURL);
      return;
    }
    
    // For Page accounts, show platform selection modal
    setPendingContentId(ContentID);
    setPendingImageURL(imageURL); // Store image URL separately
    // Reset selected platforms to default (all platforms) when opening modal
    setSelectedPlatforms(availablePlatforms.map(p => p.code));
    setShowPlatformModal(true);
  };

  // Handle confirm from platform selection modal
  const handleConfirmPlatformSelection = async () => {
    if (!pendingContentId) return;
    
    if (!selectedPlatforms || selectedPlatforms.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Platform Selected',
        text: 'Please select at least one platform to post to.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#2e3192',
        timer: 2000
      });
      return;
    }
    
    setShowPlatformModal(false);
    await performApprove(pendingContentId, selectedPlatforms, pendingImageURL);
    setPendingContentId(null);
    setPendingImageURL(null);
  };

  const handleReject = async (ContentID) => {
    try {
      setRejecting((prev) => ({ ...prev, [ContentID]: true })); // Start loading

      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/rejectlatestnews`,
        {
          ContentID,
          Status: 'Archived' // or whatever status you want to set
        }
      );

      if (response.status === 200 && response.data?.message?.includes("successfully")) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Post Archived successfully!',
          showConfirmButton: false,
          timer: 3000
        });

        setPosts((prevPosts) => prevPosts.filter(post => post.ContentID !== ContentID));
        // Refetch current status after wishlist change
        fetchPosts(statusFilter, true);
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error rejecting post!',
          text: response.data?.message || "Unknown error occurred",
          showConfirmButton: false,
          timer: 3000
        });
      }
    } catch (error) {
      console.error('Error rejecting post:', error);
      Swal.fire({
        position: 'center',
        icon: 'error',
        text: error.response?.data?.message || error.message,
        showConfirmButton: false,
        timer: 3000
      });
    } finally {
      setRejecting((prev) => ({ ...prev, [ContentID]: false })); // Stop loading
    }
  };
  const handleWishlist = async (ContentID) => {
    try {
      setWishlistLoading((prev) => ({ ...prev, [ContentID]: true }));

      // Send API call to add/remove from wishlist
      const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/rejectlatestnews`, {
        ContentID,
        Status: 'WishListed'
      });


      if (response.status === 200 && response.data?.message?.includes("successfully")) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Post added to WishList successfully!',
          showConfirmButton: false,
          timer: 3000
        });

        setPosts((prevPosts) => prevPosts.filter(post => post.ContentID !== ContentID));
        fetchPosts();
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error adding to wishlist!',
          text: response.data?.message || "Unknown error occurred",
          showConfirmButton: false,
          timer: 3000
        });
      }
    } catch (error) {
      console.error('Error adding to wishlist:', error);
      Swal.fire({
        position: 'center',
        icon: 'error',
        text: error.response?.data?.message || error.message,
        showConfirmButton: false,
        timer: 3000
      });
    } finally {
      setWishlistLoading((prev) => ({ ...prev, [ContentID]: false })); // Stop loading
    }
  };


  const fetchInterestData = async () => {
    setIsLoading(true);
    if (UserID) {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getInterestsprompts/${UserID}`);
        if (response.status === 200 && response.data) {
          const data = response.data?.map(prompt => ({
            id: prompt.InterestsPromptID, // Ensure this is mapped correctly
            text: prompt.InterestsPromptData,
            IsActive: prompt.IsActive,
            isEditing: false, // Initialize the editing state
            PromptType: prompt.PromptType
          }));
          setPromptDatainterest(data);
          console.log('Mapped Data:', data); // Log to confirm the mapping
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchInterestData();
  }, [UserID]);

  // Fetch platforms based on AccountType
  useEffect(() => {
    const fetchPlatforms = async () => {
      setPlatformsLoading(true);
      const storedAccountType = localStorage.getItem('AccountType');
      
      // For User accounts, automatically use LinkedIn only (no UI needed)
      if (storedAccountType === 'User' || storedAccountType === 'user') {
        setSelectedPlatforms(['linkedin']);
        setEnabledPlatforms([{ name: 'LinkedIn', code: 'linkedin' }]);
        setAvailablePlatforms([{ name: 'LinkedIn', code: 'linkedin' }]);
        setPlatformsLoading(false);
        return;
      }
      
      // For Page accounts, fetch all active platforms and show selection UI
      const platforms = await getAllActivePlatforms();
      setAvailablePlatforms(platforms);
      setEnabledPlatforms(platforms);
      // Default to all platforms selected for Page accounts
      setSelectedPlatforms(platforms.map(p => p.code));
      setSchedulePlatforms(platforms.map(p => p.code));
      setPlatformsLoading(false);
    };
    fetchPlatforms();
  }, []);

  const handleInterestEdit = (index) => {
    const updatedPrompts = [...promptDatainterest];
    updatedPrompts[index].isEditing = true; // Mark the prompt as being edited
    setPromptDatainterest(updatedPrompts);

    console.log('Editing prompt:', updatedPrompts[index]); // This should show the correct ID
  };



  const handleToggleInterest = async (index) => {
    const updatedPrompts = [...promptDatainterest];
    const selectedPrompt = updatedPrompts[index];

    // Count the currently active prompts
    const activeCount = updatedPrompts.filter(p => p.IsActive).length;

    // If trying to activate and already 10 active, block it
    if (!selectedPrompt.IsActive && activeCount >= 10) {
      Swal.fire({
        icon: 'warning',
        title: 'Limit Reached',
        text: 'You can only have up to 10 active interests.',
        showConfirmButton: false,
        timer: 2500
      });
      return;
    }

    // Call backend to toggle IsActive
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/deleteInterestsprompt/${selectedPrompt.id}`;
      await axios.delete(url);

      // Fetch fresh data or manually update IsActive value
      updatedPrompts[index].IsActive = !selectedPrompt.IsActive; // update after backend toggles
      setPromptDatainterest(updatedPrompts);

      Swal.fire({
        icon: 'success',
        title: `Prompt ${!selectedPrompt.IsActive ? 'deactivated' : 'activated'} successfully!`,
        showConfirmButton: false,
        timer: 2000
      });
    } catch (error) {
      console.error('Error toggling Feed Interests:', error);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'An error occurred while updating the Feed Interest.',
        text: error.message || 'Please try again later.',
        showConfirmButton: false,
        timer: 3000
      });
    }
  };

  const addInterestPromptField = () => {
    // Count the active prompts
    const activeCount = promptDatainterest.filter(p => p.IsActive).length;

    // If there are already 10 active prompts, show a warning
    if (activeCount >= 10) {
      Swal.fire({
        icon: 'warning',
        title: 'Limit Reached',
        text: 'You can only have up to 10 active interests.',
        showConfirmButton: false,
        timer: 2500
      });
      return; // Exit the function if there are already 10 active prompts
    }

    // If the limit is not reached, add a new prompt
    setPromptDatainterest([

      { id: null, text: '', isEditing: true, IsActive: false, PromptType: "own" },
      ...promptDatainterest,
    ]);
  };

  const handleInterestPromptChange = (index, value) => {
    const updatedPrompts = [...promptDatainterest];
    updatedPrompts[index].text = value; // Ensure the text is set correctly
    setPromptDatainterest(updatedPrompts);
  };
  const handleInterestSave = async (index) => {
    const prompt = promptDatainterest[index];
    console.log('Saving prompt:', prompt); // Check the prompt details

    setLoadingSubmit(true);
    if (!UserID) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'UserID is missing.',
        showConfirmButton: false,
        timer: 3000
      });
      setLoadingSubmit(false);
      return;
    }
    try {
      const url = prompt.id
        ? `${process.env.REACT_APP_API_BASE_URL}/api/updateinteretsprompts`
        : `${process.env.REACT_APP_API_BASE_URL}/api/saveinteretsprompts`;
      // Prepare form data based on whether it's an update or save
      const formData = {
        InterestsPromptID: prompt.id || undefined, // Include ID only for existing prompts
        InterestsPromptData: prompt.text,
        UserID: prompt.id ? undefined : UserID, // Only include UserID if it's a new prompt
        PromptType: 'own'
      };
      console.log('Form Data being sent:', formData); // Log for debugging
      if (prompt.id) {
        // Update existing prompt
        await axios.put(url, formData);
      } else {
        // Create new prompt
        const response = await axios.post(url, formData);
        const newPromptId = response.data.InterestsPromptID;
        const updatedPrompts = [...promptDatainterest];
        updatedPrompts[index].id = newPromptId; // Assign the new ID
        setPromptDatainterest(updatedPrompts);
      }
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Feed Interests saved successfully!',
        showConfirmButton: false,
        timer: 3000
      });
      // Reset to not editable after saving
      const updatedPrompts = [...promptDatainterest];
      updatedPrompts[index].isEditing = false; // Set isEditing to false after saving
      setPromptDatainterest(updatedPrompts);

      fetchInterestData();
    } catch (error) {
      console.error('Error saving Feed Interests:', error);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'An error occurred while saving the Feed Interests.',
        showConfirmButton: false,
        timer: 3000
      });
    } finally {
      setLoadingSubmit(false);
    }
  };
  const handleCreatePoll = async (postData) => {
    setPost({...postData})
    try {
      mutate(
        {
          prompt: postData.Content,  // Assuming post.content contains the relevant prompt
        }, {
        onSuccess: (data) => {
          setQuestionData({
            question: data.newContent.question,
            options: data.newContent.options.slice(0, 4),
          });
          setShowPollModal(true);
        }
        , onError: (error) => {
          console.error("Error generating poll:", error);
          Swal.fire("Error", "Poll generation failed", "error");
        }
      }
      )
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };
  const handlePollSubmit = async () => {
    try {
      const validOptions = questionData.options.filter((opt) => opt.trim() !== "");

      if (!questionData.question.trim() || validOptions.length < 2) {
        Swal.fire("Error", "Please enter a question and at least two options.", "warning");
        return;
      }
      
    const tooLongOptions = validOptions.filter(opt => opt.length > 30);
    if (tooLongOptions.length > 0) {
      Swal.fire("Error", "Each option must be 30 characters or less.", "warning");
      return;
    }

      const postid =  SinglePost?.InterestsPromptID;         // assuming `post` is set from handleCreatePoll
      const contentid = SinglePost?.ContentID;   // same as above
console.log(`Post ID: ${SinglePost.InterestsPromptID}, Content ID: ${contentid}`);

      const questionwithoptions = {
        question: questionData.question,
        options: validOptions,
      };

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/updateFeedPollQuestionwithOptions`, {
        postid,
        contentid,
        questionwithoptions: JSON.stringify(questionwithoptions),
        pollrequired: true,                // Always passing `true` as per your requirement
        PollDuration: durationDays,        // assuming you are managing `durationDays` from dropdown
      });

      if (response.data.message === "updated successfully") {
        Swal.fire("Success", "Poll created successfully", "success");
        setShowPollModal(false);
        fetchInterestData(); // Refresh the interest data to reflect the new poll
      } else {
        Swal.fire("Error", "Failed to post poll", "error");
      }

    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Poll creation failed", "error");
    }
  };

  // Styles matching pending posts design
  const styles = {
    pageCard: { border: 'none', backgroundColor: 'transparent' },
    headerBar: { borderRadius: '18px', padding: '18px 24px', backgroundColor: '#ffffff', border: '1px solid #eef0f8' },
    headerTitle: { fontSize: '22px', color: '#2e3192', fontWeight: 700, margin: 0 },
    refreshButton: { borderRadius: '999px', paddingInline: '18px', paddingBlock: '10px', fontWeight: 600 },
    gridRow: { marginTop: '4px' },
    card: { borderRadius: '22px', border: '1px solid #eef0f8', padding: '24px', backgroundColor: '#ffffff', minHeight: '100%', display: 'flex', flexDirection: 'column' },
    cardContent: { display: 'flex', flexDirection: 'column', gap: '20px', flexGrow: 1 },
    sectionTitle: { fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#858aad', fontWeight: 600, marginBottom: '8px' },
    scheduleHeading: { fontSize: '20px', color: '#2e3192', fontWeight: 700, marginBottom: '4px' },
    scheduleSubheading: { fontSize: '14px', color: '#6c7293', marginBottom: 0 },
    timezoneChip: { backgroundColor: '#eef0ff', color: '#2e3192', borderRadius: '999px', padding: '6px 12px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center' },
    expiredBadge: { backgroundColor: '#ffe9e9', color: '#d9534f', borderRadius: '999px', padding: '6px 14px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center', marginTop: '8px' },
    metaStack: { display: 'flex', flexDirection: 'column', gap: '8px' },
    mediaWrapper: {
      position: 'relative',
      borderRadius: '22px',
      background: 'linear-gradient(135deg, rgba(46,49,146,0.12) 0%, rgba(107,99,255,0.08) 100%)',
      padding: '18px',
      marginTop: '20px',
      overflow: 'hidden'
    },
    mediaHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
    mediaBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '12px',
      fontWeight: 700,
      color: '#2e3192',
      backgroundColor: '#ffffff',
      borderRadius: '999px',
      padding: '8px 14px',
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      boxShadow: '0 4px 12px rgba(46,49,146,0.15)'
    },
    mediaPreviewShell: {
      borderRadius: '18px',
      backgroundColor: '#fff',
      padding: '12px',
      boxShadow: '0 8px 24px rgba(46,49,146,0.12)'
    },
    mediaPreview: {
      borderRadius: '14px',
      overflow: 'hidden',
      backgroundColor: '#0f172a',
      height: '220px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    mediaFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '14px',
      color: '#4f5480',
      fontSize: '12px'
    },
    mediaFilename: { fontWeight: 600, wordBreak: 'break-all' },
    captionSection: { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: '12px' },
    contentBox: { backgroundColor: '#f8f9ff', borderRadius: '18px', padding: '18px', color: '#34385b', whiteSpace: 'pre-wrap', flexGrow: 1, overflowY: 'auto' },
    promptBox: { backgroundColor: '#ffffff', border: '1px dashed #d9dcff', borderRadius: '18px', padding: '18px', color: '#4f5480' },
    actionIconButton: { borderRadius: '12px', border: '1px solid #eef0f8', backgroundColor: '#f7f8ff', padding: '10px 12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
    actionIcon: { fontSize: '20px' },
    actionsWrapper: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(52px, 1fr))', gap: '14px', marginTop: '16px', width: '100%' },
    toggleLink: { marginTop: '8px', fontWeight: 600, color: '#2e3192', cursor: 'pointer', border: 'none', background: 'transparent', padding: 0 },
  };

  // Helper function for ActionButton component
  const ActionButton = ({ icon, label, onClick, disabled, tooltip, variant = 'outline-primary', loading = false }) => {
    const variantColor = (() => {
      switch (variant) {
        case 'success':
          return '#28a745';
        case 'outline-danger':
          return '#ff4d4d';
        case 'outline-dark':
          return '#343a40';
        default:
          return '#2e3192';
      }
    })();

    const button = (
      <button
        type="button"
        className="btn btn-icon-only"
        style={{ ...styles.actionIconButton, opacity: disabled || loading ? 0.6 : 1 }}
        onClick={onClick}
        disabled={disabled || loading}
      >
        <FontAwesomeIcon
          icon={loading ? faSpinner : icon}
          spin={loading}
          style={{ ...styles.actionIcon, color: variantColor }}
        />
        <span className="visually-hidden">{label}</span>
      </button>
    );

    if (!tooltip) {
      return button;
    }

    return (
      <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-${label.replace(/\s+/g, '-').toLowerCase()}`}>{tooltip}</Tooltip>}>
        <span className="d-inline-flex">{button}</span>
      </OverlayTrigger>
    );
  };

  // Helper functions for date/time formatting
  const handleDate = (scheduledDate) => {
    if (!scheduledDate) return { date: '' };
    const dateTimeString = `${scheduledDate?.split('T')[0]}`;
    const dateTime = moment.utc(dateTimeString);
    const date = dateTime.format('YYYY-MM-DD');
    return { date };
  };

  const handleTime = (value) => {
    if (!value) return '';
    if (moment.parseZone(value, moment.ISO_8601, true).isValid()) {
      return moment.parseZone(value, moment.ISO_8601, true).format('hh:mm A');
    }
    if (moment(value, 'HH:mm', true).isValid()) {
      return moment(value, 'HH:mm', true).format('hh:mm A');
    }
    return value;
  };

  // Media handling functions
  const resolveMediaDetails = (mediaPath = '') => {
    if (!mediaPath || mediaPath === 'null' || mediaPath === 'undefined' || mediaPath.trim() === '') {
      return null;
    }
    
    const normalized = `${mediaPath}`.trim().replace(/\\/g, '/');
    if (!normalized) return null;

    const isFullUrl = /^https?:\/\//i.test(normalized);
    const isAzureBlobUrl = normalized.includes('blob.core.windows.net');
    const isLinkedInAsset = normalized.includes('linkedin.com') || normalized.includes('media.licdn.com');

    const pathWithoutQuery = normalized.split('?')[0];
    const extension = pathWithoutQuery.split('.').pop()?.toLowerCase() || '';
    const filename = pathWithoutQuery.split(/[/\\]/).pop() || '';

    let mediaType = 'unknown';
    
    // Check for video extensions
    if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
      mediaType = 'video';
    } 
    // Check for image extensions
    else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension)) {
      mediaType = 'image';
    }
    // Check for LinkedIn assets (usually images)
    else if (isLinkedInAsset) {
      mediaType = 'image';
    }
    // Check for Azure blob URLs - try to detect from URL pattern or content type
    else if (isAzureBlobUrl) {
      // Azure blob URLs might not have extensions, check URL pattern
      // Most Azure blob URLs for images contain 'image' in the path or are common image patterns
      const lowerPath = normalized.toLowerCase();
      if (lowerPath.includes('/image/') || lowerPath.includes('image') || 
          lowerPath.match(/\.(jpg|jpeg|png|gif|bmp|webp|svg)/i)) {
        mediaType = 'image';
      } else if (lowerPath.includes('/video/') || lowerPath.includes('video') ||
                 lowerPath.match(/\.(mp4|mov|avi|mkv|webm)/i)) {
        mediaType = 'video';
      } else {
        // Default to image for Azure blob URLs without clear indication
        mediaType = 'image';
      }
    }
    // If no extension but it's a full URL, try to infer from URL structure
    else if (isFullUrl && !extension) {
      // Many image hosting services don't use extensions
      // Default to image for full URLs without extension
      mediaType = 'image';
    }

    // Build source URL
    let source;
    if (isFullUrl || isAzureBlobUrl || isLinkedInAsset) {
      source = normalized;
    } else {
      // For relative paths, prepend API base URL
      const cleanPath = normalized.startsWith('/') ? normalized : `/${normalized}`;
      source = `${process.env.REACT_APP_API_BASE_URL}${cleanPath}`;
    }

    // Normalize image URLs for production (same as home.js)
    if (source.includes('localhost') || source.includes('127.0.0.1')) {
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';
      if (apiBaseUrl) {
        try {
          const urlObj = new URL(source);
          source = `${apiBaseUrl}${urlObj.pathname}${urlObj.search}`;
        } catch (e) {
          console.warn('⚠️ Failed to parse URL:', source, e);
        }
      }
    }

    return {
      source: encodeURI(source),
      mediaType,
      filename,
    };
  };

  const renderMediaPreview = (mediaDetails) => {
    if (!mediaDetails) {
      return (
        <div className="text-muted">
          Media not available.
        </div>
      );
    }

    if (mediaDetails.mediaType === 'video') {
      return (
        <video
          controls
          style={{ width: '100%', height: '100%', maxHeight: '320px', borderRadius: '14px' }}
          onError={(e) => {
            // If video fails, try to show as image
            const img = document.createElement('img');
            img.src = mediaDetails.source;
            img.style.cssText = 'width: 100%; height: 100%; object-fit: contain;';
            img.alt = 'Post media';
            e.currentTarget.parentNode.replaceChild(img, e.currentTarget);
          }}
        >
          <source src={mediaDetails.source} />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (mediaDetails.mediaType === 'image' || mediaDetails.mediaType === 'unknown') {
      // Try to render as image even if type is unknown (many URLs don't have extensions)
      return (
        <img
          src={mediaDetails.source}
          alt="Post media"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          onError={(e) => {
            // If image fails to load, show error message
            e.currentTarget.style.display = 'none';
            const errorDiv = document.createElement('div');
            errorDiv.className = 'text-muted';
            errorDiv.style.cssText = 'padding: 20px; text-align: center;';
            errorDiv.textContent = 'Preview not available for this file type.';
            e.currentTarget.parentNode.appendChild(errorDiv);
          }}
          onLoad={() => {
            // If image loads successfully, remove any error messages
            const parent = document.querySelector('[style*="padding: 20px"]');
            if (parent && parent.textContent.includes('Preview not available')) {
              parent.remove();
            }
          }}
        />
      );
    }

    return (
      <div className="text-muted">
        Preview not available for this file type.
      </div>
    );
  };

  const getMediaIcon = (mediaType) => (mediaType === 'video' ? faVideo : faImage);
  const getMediaLabel = (mediaType) => {
    if (mediaType === 'video') return 'Video Attachment';
    if (mediaType === 'image') return 'Image Attachment';
    return 'Media Attachment';
  };
  const getMediaInteractionHint = (mediaType) => {
    if (mediaType === 'video') return 'Tap to play';
    if (mediaType === 'image') return 'Tap to zoom';
    return 'View media';
  };
  const getMediaFilename = (mediaDetails) => {
    if (!mediaDetails) return '';
    return mediaDetails.filename;
  };

  const handleMediaPreviewClick = (mediaDetails) => {
    if (!mediaDetails || mediaDetails.mediaType === 'unknown') return;
    setActiveMedia(mediaDetails);
    setShowMediaModal(true);
  };

  const handleCloseMediaModal = () => {
    setShowMediaModal(false);
    setActiveMedia(null);
  };

  const renderModalMedia = () => {
    if (!activeMedia) return null;

    if (activeMedia.mediaType === 'video') {
      return (
        <video controls style={{ width: '100%', borderRadius: '12px' }}>
          <source src={activeMedia.source} />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (activeMedia.mediaType === 'image') {
      return (
        <img
          src={activeMedia.source}
          alt={activeMedia.filename || 'Preview'}
          style={{ width: '100%', borderRadius: '12px', objectFit: 'contain' }}
        />
      );
    }

    return null;
  };

  const toggleContent = (contentId) => {
    setExpandedPosts(prev => ({ ...prev, [contentId]: !prev[contentId] }));
  };

  return (
    <div className="">
      <FloatingUsageIndicator
        featureName={FEATURE_NAMES.KNACK_FEEDS}
        position="top-right"
      />
      <SideNavbar>

        <div className="card shadow-sm p-3 mt-3" style={{ border: 'none', backgroundColor: '#fff' }}>
          <div className="card-header d-flex justify-content-between" style={{ border: 'none', backgroundColor: '#fff' }}>

            <div className=''>
              <Link to={localStorage.getItem('RoleID') == '4' ? '/Pagehome' : (localStorage.getItem('RoleID') == '1' ? '/home' : '/adminhome')}>
                <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}><i class="fa fa-arrow-left" style={{ marginRight: '30px' }} aria-hidden="true"></i>Knack Feeds</h5>
              </Link></div>
            <div>
            </div>

          </div>
          <hr />

          {/* interests */}
          <p className="mb-2" style={{ color: '#2e3192', fontWeight: 'bold', marginTop: "15px" }}>Add your interests like Technology & innovations, Artificial Intelligence, Blockchain, cybersecurity, Finance Management, Acquisitions and more for Trending Knack feeds.</p>

          <div className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <div className="accordion-header shadow-sm" id="flush-headingOne">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                  <h5>Feed Interests</h5>
                </button>
              </div>
              <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div className="accordion-body">

                  <div className="row">
                    <div style={{ textAlign: 'right' }}>
                      <button
                        type="button"
                        onClick={addInterestPromptField} // You need to implement this function
                        style={{ margin: '10px 0' }}
                      >
                        +
                      </button>
                    </div>
                    {promptDatainterest.map((prompt, index) => {
                      // Log the current item to ensure data structure
                      

                      return (
                        <div key={index} className="col-md-6 col-lg-4 mb-4">
                          <div className="card" style={{ height: 250 }}>
                            <div className="card-body schedule-card">
                              <textarea
                                placeholder={`Interest Prompt`}
                                value={prompt.text}
                                onChange={(e) => handleInterestPromptChange(index, e.target.value)} // Implement this function
                                disabled={!prompt.isEditing} // Manage editing state similarly to AI Prompts
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  padding: '0px',
                                  resize: 'none',
                                  background: 'none',
                                  backgroundColor: prompt.PromptType === 'own' ? 'transparent' : '#e6f2ff',
                                  border: 'none',
                                }}
                              />
                            </div>
                            <div className="card-footer">
                              <div className="d-flex justify-content-between">
                                {prompt.isEditing ? (
                                  <>
                                    <button
                                      type="button"
                                      onClick={() => handleInterestSave(index)} // Implement this function
                                      className="btn btn-success"
                                      disabled={loadingSubmit}
                                    >
                                      <FontAwesomeIcon icon={faSave} />
                                    </button>
                                    {/* <button
              type="button"
              onClick={() => handleToggleInterest(index)} // Implement this function
              className="btn btn-danger"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button> */}
                                    <button
                                      type="button"
                                      onClick={() => handleToggleInterest(index)} // Implement this function
                                      className="btn btn-danger"
                                    >
                                      <i
                                        className={`fa fa-${prompt.IsActive ? 'toggle-on' : 'toggle-off'}`}
                                        aria-hidden="true"
                                        style={{ fontSize: 20, color: '#fff' }} // Icon is always white
                                      ></i>
                                      {/* No trash icon */}
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      type="button"
                                      onClick={() => handleInterestEdit(index)} // Implement this function
                                      className="btn btn-primary"
                                    >
                                      <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button
                                      className={`btn ${prompt.IsActive ? 'btn-success' : 'btn-danger'}`}
                                      onClick={() => handleToggleInterest(index)} // Use your toggle function
                                    >
                                      <i
                                        className={`fa fa-${prompt.IsActive ? 'toggle-on' : 'toggle-off'}`}
                                        aria-hidden="true"
                                        style={{ fontSize: 20, color: '#fff' }} // Icon is always white
                                      ></i>
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                  </div>

                </div>
              </div>
            </div>
          </div>

          <h5 className='mt-3' style={{ fontWeight: 'bold' }}>Pending Knack Feeds</h5>




          <div class="mt-3">
            <p style={{ color: '#2e3192', fontWeight: 'bold' }}>Stay updated with the latest news! An email with knack Feeds will be generated every 12 hours, delivering timely insights on current events.</p>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6'>
              <div
                className="d-flex justify-content-end"
                style={{
                  maxWidth: '100%', // or use container maxWidth if needed
                  width: '50%',
                  marginBottom: 10,
                }}
              >
                <select
                  className="form-select"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  style={{
                    padding: '0.5rem',
                    borderRadius: '5px',
                    borderColor: '#2e3192',
                    fontSize: '14px',
                  }}
                >
                  <option value="Pending">Pending Feeds</option>
                  <option value="WishListed">Wishlisted Feeds</option>
                  <option value="Archived">Archived Feeds</option>
                </select>
              </div>
            </div>
          </div>

          <div className="container" style={{ marginTop: '4px' }}>
            {loading ? (
              <div className='spinner'></div>
            ) : posts.length === 0 ? (
              <div style={{ textAlign: 'center' }}>
                <img src={noDataImage} alt="No Data" style={{ width: '50%' }} />
                <p style={{ color: '#2e3192', fontSize: '20px' }}>No posts available</p>
              </div>
            ) : (
              <div className="row g-4" style={styles.gridRow}>
                {currentPosts.map(post => {


                  return (





                    <div className="col-12 col-md-6" key={post.ContentID}>
                      <div className="shadow-sm h-100" style={styles.card}>
                        <div style={styles.cardContent}>
                          {(() => {
                            const { date } = handleDate(post?.ScheduledDate);
                            const time = handleTime(post?.ScheduledTimeAsPerZone);
                            // Try multiple possible field names for image URL
                            const mediaPath = post?.ImageURL || post?.PostImage || post?.MediaURL || post?.Image || '';
                            const mediaDetails = resolveMediaDetails(mediaPath);
                            
                            // Debug logging (can be removed in production)
                            if (mediaPath && !mediaDetails) {
                              console.warn('⚠️ Media path exists but could not resolve:', mediaPath);
                            }
                            
                            return (
                              <>
                                {post?.ScheduledDate && (
                                  <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
                                    <div style={styles.metaStack}>
                                      <span style={styles.sectionTitle}>Scheduled for</span>
                                      <div>
                                        <div style={styles.scheduleHeading}>{date}</div>
                                        <p style={styles.scheduleSubheading}>{time}</p>
                                      </div>
                                    </div>
                                    <div className="text-end d-flex flex-column align-items-end gap-2">
                                      {post?.TimeZone && <span style={styles.timezoneChip}>{post.TimeZone}</span>}
                                    </div>
                                  </div>
                                )}

                                <div>
                                  <div style={styles.sectionTitle}>Prompt</div>
                                  <div style={styles.promptBox}>{post?.InterestsPromptData || 'No prompt provided.'}</div>
                                </div>

                                {mediaDetails && (
                                  <div style={styles.mediaWrapper}>
                                    <div style={styles.mediaHeader}>
                                      <span style={styles.mediaBadge}>
                                        <FontAwesomeIcon
                                          icon={getMediaIcon(mediaDetails.mediaType)}
                                          style={{ fontSize: '16px' }}
                                        />
                                        {getMediaLabel(mediaDetails.mediaType)}
                                      </span>
                                    </div>
                                    <div style={styles.mediaPreviewShell}>
                                      <div
                                        style={{
                                          ...styles.mediaPreview,
                                          cursor: mediaDetails.mediaType !== 'unknown' ? 'zoom-in' : 'default'
                                        }}
                                        role={mediaDetails.mediaType !== 'unknown' ? 'button' : undefined}
                                        tabIndex={mediaDetails.mediaType !== 'unknown' ? 0 : undefined}
                                        onClick={() => handleMediaPreviewClick(mediaDetails)}
                                        onKeyDown={(event) => {
                                          if (event.key === 'Enter' || event.key === ' ') {
                                            event.preventDefault();
                                            handleMediaPreviewClick(mediaDetails);
                                          }
                                        }}
                                      >
                                        {renderMediaPreview(mediaDetails)}
                                      </div>
                                    </div>
                                    {mediaDetails.mediaType !== 'unknown' && (
                                      <div style={styles.mediaFooter}>
                                        <span>{getMediaInteractionHint(mediaDetails.mediaType)}</span>
                                      </div>
                                    )}
                                  </div>
                                )}

                                <div style={styles.captionSection}>
                                  <div style={styles.sectionTitle}>Post Caption</div>
                                  <div style={styles.contentBox}>
                                    {(() => {
                                      const content = post?.Content || 'No content available.';
                                      const isExpanded = !!expandedPosts[post.ContentID];
                                      let displayContent = isExpanded || content.length <= 220 ? content : `${content.slice(0, 220)}...`;
                                      
                                      // Function to convert URLs to clickable links
                                      const makeLinksClickable = (text) => {
                                        // Regular expression to match URLs (http, https, or www)
                                        const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
                                        const parts = text.split(urlRegex);
                                        
                                        return parts.map((part, index) => {
                                          // Check if this part matches the URL pattern
                                          if (/(https?:\/\/|www\.)/i.test(part)) {
                                            // Ensure URL has protocol
                                            const url = part.startsWith('http') ? part : `https://${part}`;
                                            return (
                                              <a
                                                key={index}
                                                href={url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                  color: '#1976d2',
                                                  textDecoration: 'underline',
                                                  wordBreak: 'break-all'
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                              >
                                                {part}
                                              </a>
                                            );
                                          }
                                          return <span key={index}>{part}</span>;
                                        });
                                      };
                                      
                                      return makeLinksClickable(displayContent);
                                    })()}
                                  </div>
                                  {post?.Content && post.Content.length > 220 && (
                                    <button style={styles.toggleLink} onClick={() => toggleContent(post.ContentID)}>
                                      {expandedPosts[post.ContentID] ? 'Show Less' : 'Read More'}
                                    </button>
                                  )}
                                </div>

                              </>
                            );
                          })()}
                        </div>

                        <div className="mt-4" style={styles.actionsWrapper}>
                          <ActionButton
                            icon={faEdit}
                            label="Edit"
                            tooltip="Edit content details"
                            onClick={() => handleedit(post)}
                          />

                          {!post.ScheduledDate && (
                            <ActionButton
                              icon={faClock}
                              label="Schedule Post"
                              tooltip="Schedule this post"
                              onClick={() => handleschedulepost(post)}
                            />
                          )}

                          <ActionButton
                            icon={faHeart}
                            label="Add to Wishlist"
                            tooltip="Add to wishlist"
                            onClick={() => handleWishlist(post.ContentID)}
                            loading={!!wishlistLoading[post.ContentID]}
                          />

                          <ActionButton
                            icon={faPoll}
                            label="Create Poll"
                            tooltip="Generate a poll for this post"
                            onClick={() => handleCreatePoll(post)}
                            loading={loadingPoll && SinglePost.ContentID === post.ContentID}
                          />

                          <ActionButton
                            icon={faThumbsUp}
                            label="Approve"
                            variant="success"
                            tooltip="Approve and post"
                            onClick={() => handleApprove(post.ContentID, post)}
                            loading={!!approving[post.ContentID]}
                          />

                          <ActionButton
                            icon={faTrash}
                            label="Archive"
                            variant="outline-danger"
                            tooltip="Archive this post"
                            onClick={() => handleReject(post.ContentID)}
                            loading={!!rejecting[post.ContentID]}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

            )}
          </div>
          <div style={{ marginTop: '40px' }}>
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={(selectedItem) =>
                setCurrentPage(selectedItem.selected)
              }
              containerClassName={"pagination"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              activeClassName={"active"}
              disabledClassName={"disabled"}
              breakLabel={"..."}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              marginPagesDisplayed={isMobile ? 1 : 2}
              pageRangeDisplayed={isMobile ? 1 : 3}
            />
          </div>
          <Modal show={showMediaModal} onHide={handleCloseMediaModal} size="lg" centered>
            <Modal.Header closeButton>
              <Modal.Title>Media Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {renderModalMedia()}
            </Modal.Body>
          </Modal>
          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title style={{ color: "#2e3192" }}>KnackFeeds Schedule</Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                    {/* Email field hidden as requested */}
                    {/* <div>
                      <label style={{ textAlign: 'left', marginTop: '15px' }}>Email:</label>
                      <input
                        type="email"
                        defaultValue={LinkedinEmail}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div> */}
                    <div>
                      <label style={{ textAlign: 'left', marginTop: '15px' }}>Schedule Date & Time:</label>
                      <input
                        type="datetime-local"
                        value={scheduleDateTime}
                        onChange={handleScheduleDateTimeChange}
                      />
                    </div>


                  </div>
                  <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">


                    <div>
                      <label style={{ textAlign: 'left', marginTop: '15px' }}>Timezone:</label>
                      <TimezoneSelect
                        value={selectedTimezone}
                        onChange={setSelectedTimezone}
                      />
                    </div>
                  </div>
                </div>
                
                {/* Platform Selection for Schedule Modal */}
                {(() => {
                  const currentAccountType = localStorage.getItem('AccountType');
                  const isPageAccount = currentAccountType === 'Page' || currentAccountType === 'page';
                  
                  if (!isPageAccount) {
                    // For User accounts, don't show platform selection (LinkedIn is auto-selected)
                    return null;
                  }
                  
                  // For Page accounts, show platform selection
                  if (platformsLoading || !availablePlatforms || availablePlatforms.length === 0) {
                    return (
                      <div style={{ marginTop: '20px' }}>
                        <label style={{ textAlign: 'left', marginBottom: '10px', display: 'block', fontWeight: '500' }}>
                          Select Platforms:
                        </label>
                        <p style={{ color: '#666', fontSize: '14px' }}>Loading platforms...</p>
                      </div>
                    );
                  }
                  
                  return (
                    <div style={{
                      marginTop: '20px',
                      padding: '16px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                      border: '1px solid #e0dfdc'
                    }}>
                      <label style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#2e3192',
                        marginBottom: '12px',
                        display: 'block'
                      }}>
                        Select Platforms to Post To:
                      </label>
                      <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '16px',
                        alignItems: 'center'
                      }}>
                        {availablePlatforms.map((platform) => {
                          const platformIcons = {
                            linkedin: <FaLinkedin style={{ color: '#0077b5', fontSize: '24px' }} />,
                            facebook: <FaFacebook style={{ color: '#1877F2', fontSize: '24px' }} />,
                            instagram: <FaInstagram style={{ color: '#E4405F', fontSize: '24px' }} />
                          };
                          const isSelected = schedulePlatforms.includes(platform.code);
                          
                          return (
                            <label
                              key={platform.code}
                              title={platform.name}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                padding: '10px',
                                borderRadius: '8px',
                                backgroundColor: isSelected ? '#e8f0fe' : 'white',
                                border: `2px solid ${isSelected ? '#2e3192' : '#e0dfdc'}`,
                                transition: 'all 0.2s ease',
                                userSelect: 'none',
                                minWidth: '48px',
                                height: '48px',
                                position: 'relative'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = isSelected ? '#d0e7ff' : '#f0f0f0';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = isSelected ? '#e8f0fe' : 'white';
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => handleSchedulePlatformToggle(platform.code)}
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  right: '4px',
                                  width: '16px',
                                  height: '16px',
                                  cursor: 'pointer',
                                  accentColor: '#2e3192',
                                  zIndex: 1
                                }}
                              />
                              <span style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                {platformIcons[platform.code] || <FaLinkedin style={{ fontSize: '24px' }} />}
                              </span>
                            </label>
                          );
                        })}
                      </div>
                      <small style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '8px',
                        color: '#666',
                        fontSize: '12px',
                        gap: '8px'
                      }}>
                        Selected: {schedulePlatforms.length > 0 
                          ? schedulePlatforms.map((code, index) => {
                              const platformIcons = {
                                linkedin: <FaLinkedin key={index} style={{ color: '#0077b5', fontSize: '16px' }} />,
                                facebook: <FaFacebook key={index} style={{ color: '#1877F2', fontSize: '16px' }} />,
                                instagram: <FaInstagram key={index} style={{ color: '#E4405F', fontSize: '16px' }} />
                              };
                              return platformIcons[code] || null;
                            })
                          : 'None'}
                      </small>
                    </div>
                  );
                })()}
                
                <button 
                  type="submit" 
                  className='btn btn-primary' 
                  disabled={loading || (!platformsLoading && schedulePlatforms.length === 0)} 
                  style={{ backgroundColor: "#2e3192", borderRadius: 8, marginTop: 20 }}
                >
                  {loading ? 'Scheduling...' : formatPlatformNamesForButton(availablePlatforms.filter(p => schedulePlatforms.includes(p.code)))}
                </button>
              </form>
            </Modal.Body>
            {error && <p style={{ color: 'red', marginLeft: 15 }}>{error}</p>}
          </Modal>

        </div>



      </SideNavbar>

      <Modal show={showPollModal} onHide={() => setShowPollModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Create Poll</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="question-editor">
            <label>Poll Question:</label>
            <input
              type="text"
              value={questionData.question}
              onChange={(e) =>
                setQuestionData({ ...questionData, question: e.target.value })
              }
              className="form-control mb-2"
              placeholder="Enter your question"
            />

            <label>Options:</label>
            {questionData.options.map((opt, idx) => (
              <div key={idx} className="d-flex align-items-center mb-2">
                <input
                  type="text"
                  value={opt}
                  onChange={(e) => {
                    const newOptions = [...questionData.options];
                    newOptions[idx] = e.target.value;
                    setQuestionData({ ...questionData, options: newOptions });
                  }}
                  className="form-control me-2"
                />
                {questionData.options.length > 2 && (
                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      const newOptions = questionData.options.filter((_, i) => i !== idx);
                      setQuestionData({ ...questionData, options: newOptions });
                    }}
                  >
                    <i className="fa fa-trash text-white"></i>
                  </button>
                )}
              </div>
            ))}

            {questionData.options.length < 4 && (
              <button
                className="btn btn-primary"
                onClick={() =>
                  setQuestionData({ ...questionData, options: [...questionData.options, ""] })
                }
              >
                <i className="fa fa-plus text-white"></i>
              </button>
            )}
            <div className="form-group mt-3">
              <label htmlFor="duration">Poll Duration</label>
              <select
                id="duration"
                className="form-control"
                value={durationDays}
                onChange={(e) => setDurationDays(parseInt(e.target.value))}
              >
                <option value={1}>1 Day</option>
                <option value={3}>3 Days</option>
                <option value={7}>7 Days</option>
              </select>
            </div>

          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowPollModal(false)}>
            Cancel
          </button>
          <button className="btn btn-success" onClick={handlePollSubmit}>
            Create Poll
          </button>
        </Modal.Footer>
      </Modal>

      {/* Platform Selection Modal for Approve Button */}
      <Modal show={showPlatformModal} onHide={() => { setShowPlatformModal(false); setPendingContentId(null); setPendingImageURL(null); }} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#2e3192" }}>Select Platforms</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{
            padding: '16px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e0dfdc',
            marginBottom: '20px'
          }}>
            <label style={{
              fontSize: '14px',
              fontWeight: '600',
              color: '#2e3192',
              marginBottom: '12px',
              display: 'block'
            }}>
              Select Platforms to Post To:
            </label>
            {platformsLoading || !availablePlatforms || availablePlatforms.length === 0 ? (
              <p style={{ color: '#666', fontSize: '14px' }}>Loading platforms...</p>
            ) : (
              <>
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '16px',
                  alignItems: 'center'
                }}>
                  {availablePlatforms.map((platform) => {
                    const platformIcons = {
                      linkedin: <FaLinkedin style={{ color: '#0077b5', fontSize: '24px' }} />,
                      facebook: <FaFacebook style={{ color: '#1877F2', fontSize: '24px' }} />,
                      instagram: <FaInstagram style={{ color: '#E4405F', fontSize: '24px' }} />
                    };
                    const isSelected = selectedPlatforms.includes(platform.code);
                    
                    return (
                      <label
                        key={platform.code}
                        title={platform.name}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          padding: '10px',
                          borderRadius: '8px',
                          backgroundColor: isSelected ? '#e8f0fe' : 'white',
                          border: `2px solid ${isSelected ? '#2e3192' : '#e0dfdc'}`,
                          transition: 'all 0.2s ease',
                          userSelect: 'none',
                          minWidth: '48px',
                          height: '48px',
                          position: 'relative'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = isSelected ? '#d0e7ff' : '#f0f0f0';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = isSelected ? '#e8f0fe' : 'white';
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => handlePlatformToggle(platform.code)}
                          style={{
                            position: 'absolute',
                            top: '4px',
                            right: '4px',
                            width: '16px',
                            height: '16px',
                            cursor: 'pointer',
                            accentColor: '#2e3192',
                            zIndex: 1
                          }}
                        />
                        <span style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          {platformIcons[platform.code] || <FaLinkedin style={{ fontSize: '24px' }} />}
                        </span>
                      </label>
                    );
                  })}
                </div>
                <small style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '8px',
                  color: '#666',
                  fontSize: '12px',
                  gap: '8px'
                }}>
                  Selected: {selectedPlatforms.length > 0 
                    ? selectedPlatforms.map((code, index) => {
                        const platformIcons = {
                          linkedin: <FaLinkedin key={index} style={{ color: '#0077b5', fontSize: '16px' }} />,
                          facebook: <FaFacebook key={index} style={{ color: '#1877F2', fontSize: '16px' }} />,
                          instagram: <FaInstagram key={index} style={{ color: '#E4405F', fontSize: '16px' }} />
                        };
                        return platformIcons[code] || null;
                      })
                    : 'None'}
                </small>
              </>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => { setShowPlatformModal(false); setPendingContentId(null); }}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleConfirmPlatformSelection}
            disabled={!selectedPlatforms || selectedPlatforms.length === 0}
            style={{ backgroundColor: "#2e3192", borderColor: "#2e3192" }}
          >
            {formatPlatformNamesForButton(availablePlatforms.filter(p => selectedPlatforms.includes(p.code)))}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LatestTrendingPost;

